import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';

import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { IoArrowBackCircle } from 'react-icons/io5';
import { MdOutlineClose } from 'react-icons/md';
import Moment from 'react-moment';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ListStatusProduct } from 'services/commonDate_services';
import { MoldSelectedResponsesModel, WorkOrderDetailModel } from 'services/workOrder_services';
import { commonDatePresenter, commonDateStore, workOrderPresenter, workOrderStore } from 'stores/root_store';
import { formatNumber } from 'utils/formatHelper';

export function createAddSerial() {
  return observer(() => {
    // ============ Navigation =================/
    const navigate = useNavigate();
    // Lấy parameter trên url
    const { workOrderId = '' } = useParams();
    // ==========================================//

    // ============ Loading toàn trang =========//
    const [loading, setLoading] = useState(true);
    //==========================================//
    // get list dropdown moldtest
    const [listMoldTest, setListMoldTest] = useState<ListStatusProduct[]>([]);

    // ============ tạo khuôn =================//
    const [show, setShow] = useState(false);
    // lưu id, moldCode, stepCode -> call api
    const [mold, setMold] = useState({
      workOrderId: workOrderId,
      stepCode: '',
      productId: '',
      orderIndex: 0,
    });

    const [showDelete, setShowDelete] = useState(false);

    const [workOrderDetail, setWorkOrderDetail] = useState<WorkOrderDetailModel>();
    const [moldListSelected, setmoldListSelected] = useState<MoldSelectedResponsesModel[]>([]);

    // ==================FUNCTION========================//
    const deleteWOMold = async (id: string) => {
      await workOrderPresenter.deleteWOMold(workOrderStore, id);

      setShowDelete(!showDelete);
      if (workOrderStore.deleteWOMoldResponse.isSuccess) {
        getWorkOrder();
        toast.success(workOrderStore.deleteWOMoldResponse.message);
      } else {
        toast.error(workOrderStore.deleteWOMoldResponse.message);
      }
    };

    // ============ lấy data table =================//

    // gọi api lấy work order theo id
    const getWorkOrder = async () => {
      await workOrderPresenter.getMoldByWO(workOrderStore, workOrderId);
      setLoading(false);
      if (workOrderStore.getMoldByWOResponse.data) {
        setmoldListSelected(workOrderStore.getMoldByWOResponse.data?.moldSelectedResponses);
      }
    };
    const dateNow = Date.now();

    // get list dropdown moldtest
    const getDropDownMoldTest = async () => {
      await commonDatePresenter.getDropdownMoldTestResult(commonDateStore, 'MoldTestResult');
      setListMoldTest(commonDateStore.listStatusProductResponse.data);
    };

    useEffect(() => {
      const getWorkOrderDetails = async () => {
        await workOrderPresenter.getWorkOrderDetails(workOrderStore, workOrderId);
        setWorkOrderDetail(workOrderStore.getWODetailsResponse.data);
        setLoading(false);
      };
      getWorkOrder();
      getWorkOrderDetails();
      getDropDownMoldTest();
    }, []);

    // ==========================================//

    // =============== Xử Thêm serial cho khuôn ===========//
    const handleSelectSerie = async (moldCode: string, stepCode: string, orderIndex: number) => {
      await workOrderPresenter.getProductByMold(workOrderStore, moldCode);
      setMold({ ...mold, stepCode: stepCode, orderIndex: orderIndex });
      setShow(true);
    };
    const handlSelectlMold = async (productId: string) => {
      if (mold.productId === productId) {
        setMold({ ...mold, productId: '' });
      } else {
        await workOrderPresenter.createWOMold(workOrderStore, mold);
        setMold({ ...mold, productId: productId });
      }
    };
    const handleSave = async () => {
      setLoading(true);
      await workOrderPresenter.createWOMold(workOrderStore, mold);
      if (workOrderStore.createWOMoldResponse.isSuccess) {
        getWorkOrder();
        toast.success(workOrderStore.createWOMoldResponse.message);
        setShow(false);
        setLoading(false);
      } else {
        toast.error(workOrderStore.createWOMoldResponse.message);
      }
    };
    //=====================================================//
    return (
      <div className="relative w-full p-5 py-3">
        {loading && <LoadingScreen />}
        <div className="flex items-center gap-4 mb-3">
          <h3 className="text-md font-bold text-gray-800 uppercase">Chọn serial</h3>
          {/* nút back */}
          <span
            onClick={() => navigate('./../../')}
            className="flex items-center text-xs text-primary cursor-pointer font-medium"
          >
            <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
            Quay lại
          </span>
        </div>
        {/* ================================================================= */}
        <div className="w-full bg-white py-3 px-5 rounded rounded-t-none border border-t-0 border-neutral-300 mb-2">
          <div className={`overflow-x-auto`}>
            <form className="w-full py-2 flex flex-col">
              <div className="w-3/5 text-[13px]">
                {/* Lệnh Sản Xuất*/}
                <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5">
                  <label className="font-bold  text-gray-700 text-end">Lệnh sản xuất</label>
                  <input
                    disabled
                    value={workOrderDetail?.workOrderCode || ''}
                    className="col-span-4 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* TP/BTP*/}
                <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5">
                  <label className="font-bold  text-gray-700 text-end">TP/BTP:</label>
                  <input
                    disabled
                    value={`${workOrderDetail?.productCode || ''} | ${workOrderDetail?.productName || ''}}`}
                    className="col-span-4 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
                {/* Số lượng phát lệnh*/}
                <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-5">
                  <label className="font-bold  text-gray-700 text-end">Số lượng phát lệnh:</label>
                  <input
                    disabled
                    value={workOrderDetail?.quantity || ''}
                    className="col-span-4 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  />
                </div>
              </div>
            </form>
            {/* ======================== Thông tin dùng chung ============================== */}
            <h3 className="text-default font-medium bg-primary/30 w-max px-4">Khuôn đã chọn</h3>
            <table className="mb-8 w-full table-auto border-collapse space-collapse text-default">
              <thead className="font-medium text-white bg-primary">
                <tr>
                  <th className="border-primary border-l-white p-2.5 font-medium w-[130px]">STT</th>
                  <th className="border-primary p-2.5 font-medium w-[150px]">Công đoạn</th>
                  <th className="border-primary p-2.5 font-medium w-[265px]">Hướng dẫn sản xuất</th>
                  <th className="border-primary p-2.5 font-medium w-[150px]">Mã khuôn</th>
                  <th className="border-primary p-2.5 font-medium">Tên khuôn</th>
                  <th className="border-primary p-2.5 font-medium">Số Serial</th>
                  <th className="border-primary p-2.5 font-medium w-[265px]">Hành động</th>
                </tr>
              </thead>
              <tbody>
                {moldListSelected.length > 0 ? (
                  moldListSelected.map((item, index) => (
                    <tr key={index}>
                      {/* thứ tự */}
                      <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.stt}</td>
                      {/* công đoạn */}
                      <td className="py-1.5 px-2 border whitespace-nowrap">
                        {item.orderIndex ? `${item.orderIndex} - ${item.stepName}` : item.stepName}
                      </td>
                      {/* hướng dẫn sử dụng */}
                      <td className="py-1.5 px-2 border whitespace-nowrap ">{item.productionInstruction}</td>
                      {/* mã khuôn  */}
                      <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.moldCode}</td>
                      {/* tên khuôn */}
                      <td className="py-1.5 px-2 border whitespace-nowrap">{item.moldName}</td>
                      {/* số serial */}
                      <td className="py-1.5 px-2 border whitespace-nowrap">{item.serial}</td>
                      {/* hành động */}
                      <td className="py-1.5 px-2 border whitespace-nowrap text-center">
                        <div className="flex justify-center w-full">
                          <button
                            onClick={() => {
                              setShowDelete(!showDelete);
                            }}
                            className="px-2.5 py-0.5 bg-red-600 rounded-sm text-white text-default flex items-center border border-red-500 hover:bg-red-500/80"
                          >
                            <MdOutlineClose />
                            {showDelete && (
                              <Dialog open={true} maxWidth="sm" fullWidth>
                                <DialogTitle>Xóa Serial</DialogTitle>
                                <Box
                                  position="absolute"
                                  top={0}
                                  right={0}
                                  onClick={() => {
                                    setShowDelete(!showDelete);
                                  }}
                                >
                                  <IconButton>
                                    <MdOutlineClose />
                                  </IconButton>
                                </Box>
                                <DialogContent>
                                  <Typography>Bạn có thực sự muốn xóa?</Typography>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    onClick={() => {
                                      setShowDelete(!showDelete);
                                    }}
                                    variant="outlined"
                                  >
                                    Hủy
                                  </Button>
                                  <Button onClick={() => deleteWOMold(item.id)} color="error" variant="contained">
                                    Xác Nhận
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            )}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="px-2 py-1.5 border whitespace-nowrap text-center">
                      Không tìm thấy
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <h3 className="text-default font-medium bg-primary/30 w-max px-4">Chọn khuôn sử dụng</h3>
            <table className="w-full table-auto border-collapse space-collapse text-default">
              <thead>
                <tr className="font-medium text-white bg-primary">
                  <th className="border-primary border p-2.5 font-medium w-[130px]">STT</th>
                  <th className="border-primary border p-2.5 font-medium w-[150px]">Công đoạn</th>
                  <th className="border-primary border p-2.5 font-medium w-[265px]">Hướng dẫn sản xuất</th>
                  <th className="border-primary border p-2.5 font-medium w-[150px]">Mã khuôn</th>
                  <th className="border-primary border p-2.5 font-medium">Tên khuôn</th>
                  <th className="border-primary border p-2.5 font-medium w-[265px]">Hành động</th>
                </tr>
              </thead>
              <tbody>
                {workOrderStore.getMoldByWOResponse.data?.moldNotSelectedResponses.map((item, index) => (
                  <tr key={index}>
                    <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.stt}</td>
                    {/* công đoạn */}
                    <td className="py-1.5 px-2 border whitespace-nowrap">
                      {item.orderIndex ? `${item.orderIndex} - ${item.stepName}` : item.stepName}
                    </td>
                    {/* hướng dẫn sử dụng */}
                    <td className="py-1.5 px-2 border whitespace-nowrap">{item.productionInstruction}</td>
                    {/* mã khuôn */}
                    <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.moldCode}</td>
                    {/* tên khuôn */}
                    <td className="py-1.5 px-2 border whitespace-nowrap">{item.moldName}</td>
                    {/* hành động */}
                    <td className="py-1.5 px-2 border whitespace-nowrap">
                      <div className="flex justify-center w-full">
                        <button
                          onClick={() => handleSelectSerie(item.moldCode, item.stepCode, item.orderIndex)}
                          className="px-2.5 py-0.5 bg-primary rounded-sm text-white text-default flex items-center border border-primary hover:bg-primary/80"
                        >
                          <FaRegEdit />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* ================================================================== */}
        {show && (
          <div className="w-full bg-white py-3 px-5 rounded border border-neutral-300">
            <div className={`overflow-x-auto`}>
              <table className="w-full table-auto border-collapse space-collapse text-default">
                <thead className="text-white bg-primary">
                  <tr>
                    <th className="border font-medium p-2.5 whitespace-nowrap min-w-[100px]"></th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Mã khuôn</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Tên khuôn</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Số Serial</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Tình trạng</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Thử nghiệm khuôn</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Mã film</th>

                    <th className="border font-medium p-2.5 whitespace-nowrap">Kho khuôn</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Bin</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Ngày bảo trì tiếp theo</th>
                    <th className="border font-medium p-2.5 whitespace-nowrap">Số lần dập</th>
                    {/* <th className='border font-medium p-2.5 whitespace-nowrap'>
                      Mô tả
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {workOrderStore.getProductByMoldResponse.data &&
                    workOrderStore.getProductByMoldResponse.data
                      .filter((item) => item.actived)
                      .map((item, index) => (
                        <tr
                          className={`${item.statusMold === 'BT' && 'bg-red-400'}
                            ${
                              item.statusMold === 'SD' &&
                              `${
                                item.currentStampQuantity !== null ||
                                item.stampQuantityAlert !== null ||
                                item.timeStamping !== null
                                  ? `${
                                      item.currentStampQuantity >= item.stampQuantityAlert ||
                                      Date.parse(item.mainDate) <= dateNow
                                        ? `bg-yellow-300`
                                        : 'bg-green-500'
                                    }`
                                  : ''
                              }`
                            }
                            ${item.statusMold === null && 'bg-gray-300'}
                            ${item.statusMold === 'TN' && !item.moldTest ? '!text-danger' : ''}`}
                          key={index}
                        >
                          {/* Chức năng */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-center">
                            {(item.actived && item.statusMold === 'SD') ||
                            (item.actived && item.statusMold === 'TN') ? (
                              <input
                                type="radio"
                                className="w-5 h-4"
                                name="checkboxStatusMold"
                                checked={item.productId === mold.productId}
                                onChange={() => handlSelectlMold(item.productId)}
                                onClick={() => {
                                  item.productId === mold.productId
                                    ? setMold({ ...mold, productId: '' })
                                    : setMold({
                                        ...mold,
                                        productId: item.productId,
                                      });
                                }}
                              />
                            ) : (
                              ''
                            )}
                          </td>
                          {/* Mã khuôn */}
                          <td
                            className="py-1.5 px-2 border whitespace-nowrap text-center"
                            onClick={() => console.log(item)}
                          >
                            {item.moldCode}
                          </td>
                          {/*  Tên khuôn*/}
                          <td className="py-1.5 px-2 border whitespace-nowrap">{item.moldName}</td>
                          {/* Số serial */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.serialNumber}</td>
                          {/* Tình trạng */}
                          <td className="py-1.5 px-2 border whitespace-nowrap">
                            {item.statusMold === 'BT' && 'Bảo trì'}
                            {item.statusMold === null && ''}
                            {item.statusMold === 'SD' && 'Đang sử dụng'}
                            {item.statusMold === 'TN' && 'Đang thử nghiệm'}
                          </td>
                          {/* Thử nhiệm khuôn */}
                          <td className="py-1.5 px-2 border whitespace-nowrap">
                            {/* {item.moldTest && 'Đạt'}
                            {!item.moldTest && 'Không đạt'}
                            {item.moldTest === null && 'Chưa đánh giá'} */}
                            {listMoldTest.find((i) => i.key === item.moldTest)?.value}
                          </td>
                          {/* Mã film */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-center">{item.filmCheck}</td>

                          {/* Kho khuôn */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-left">{item.locationNote}</td>
                          {/* Bin */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-left">{item.bin}</td>
                          {/* Ngày bảo trì tiếp theo */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-center">
                            {item.mainDate ? <Moment format="DD/MM/YYYY">{item.mainDate}</Moment> : ''}
                          </td>
                          {/* Số lần dập */}
                          <td className="py-1.5 px-2 border whitespace-nowrap text-center">
                            {`${formatNumber(item.currentStampQuantity, 0)}/${formatNumber(item.timeStamping, 0)}`}
                          </td>
                          {/* Mô tả */}
                          {/* <td className='py-1.5 px-2 border whitespace-nowrap text-left'>
                            {item.description}
                          </td> */}
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
            <div className="w-full flex justify-end mt-2">
              <button
                disabled={mold.productId ? false : true}
                onClick={handleSave}
                className={` ${
                  mold.productId ? 'bg-primary hover:bg-primary/80' : 'bg-primary/80'
                } px-5 py-1 rounded-base text-default text-white`}
              >
                Lưu
              </button>
            </div>
          </div>
        )}
      </div>
    );
  });
}
